import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import useHideMobileNav from '../utils/useHideMobileNav';

const MobileReportPopup = ({ title, onClose, children }) => {
  const closeBtnRef = useRef(null);
  const containerRef = useRef(null);

  useHideMobileNav(true);

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const previouslyFocused = document.activeElement;

    if (closeBtnRef.current) {
      closeBtnRef.current.focus();
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
        return;
      }
      if (e.key !== 'Tab') return;
      const container = containerRef.current;
      if (!container) return;
      const focusable = Array.from(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => !el.closest('[aria-hidden="true"]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', handleKeyDown);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    };
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      ref={containerRef}
      role="dialog"
      aria-modal="true"
      aria-label={title}
      style={{
        position: 'fixed', inset: 0, zIndex: 10500,
        display: 'flex', flexDirection: 'column',
        background: '#F6EFE8',
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: '10px 14px',
        paddingTop: 'max(10px, env(safe-area-inset-top, 10px))',
        background: '#5A4A42', color: '#fff',
        flexShrink: 0,
        minHeight: '52px',
      }}>
        <button
          ref={closeBtnRef}
          type="button"
          onClick={onClose}
          style={{
            background: 'none', border: 'none', color: '#fff',
            fontSize: '1.6rem', lineHeight: 1, cursor: 'pointer',
            padding: '0 2px', flexShrink: 0,
          }}
          aria-label="Back to report selector"
        >
          ‹
        </button>
        <span style={{
          fontWeight: 700, fontSize: '1rem', flex: 1, minWidth: 0,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {title}
        </span>
      </div>
      <div className="mrp-popup-body" style={{
        flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '12px',
        paddingBottom: 'max(12px, env(safe-area-inset-bottom, 12px))',
        WebkitOverflowScrolling: 'touch',
      }}>
        {children}
      </div>
      <style>{`
        .mrp-popup-body .d-none.d-md-block { display: block !important; }
        .mrp-popup-body .d-none.d-md-flex  { display: flex  !important; }
        .mrp-popup-body .rd-tbl-wrap { overflow-x: auto; max-height: none; }
        .mrp-popup-body .rd-shell { margin-bottom: 0; }
      `}</style>
    </div>,
    document.body
  );
};

export default MobileReportPopup;
